import { Controller } from "stimulus";

class MiniCartItemsController extends Controller {
  static values = {
    itemsInCart: Number,
  };
  static outlets = ["miniCart"];

  deleteItem(event) {
    event.preventDefault();

    const button = event.target.closest("button");
    const quantityToRemove = button.dataset.minicartitemsQuantityToRemove;

    const url = button.dataset.minicartitemsDeleteUrlValue;

    this.miniCartOutlet.deleteItem({
      detail: { quantityToRemove, url, totalItems: this.itemsInCartValue },
    });
  }

  toggleMiniCart() {
    this.miniCartOutlet.toggleMiniCartVisibility();
  }
}

Stimulus.register("miniCartItems", MiniCartItemsController);
